import invariant from '../../../lib/invariant';
import * as agentTypes from '../constants/agentTypes';
export const validAgentTypeInvariant = agentType => {
  invariant(Object.keys(agentTypes).includes(agentType), 'An invalid agent type was encountered. A valid agent type is required to build an Assignee record.');
};